import { render, staticRenderFns } from "./Conversaciones.vue?vue&type=template&id=da7efffe&scoped=true"
import script from "./Conversaciones.vue?vue&type=script&lang=js"
export * from "./Conversaciones.vue?vue&type=script&lang=js"
import style0 from "./Conversaciones.vue?vue&type=style&index=0&id=da7efffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7efffe",
  null
  
)

export default component.exports